<template>
  <div class="fill-height">
    <case-detail-sidebar></case-detail-sidebar>

    <case-detail-summary
      class="pl-10 overflow-y"
      style="height:84vh; overflow-x:hidden"
      :files="files"
    ></case-detail-summary>
    
    <case-detail-footer></case-detail-footer>
  </div>
</template>

<script>
  export default {
    name: 'CaseDetail',

    components: {
      CaseDetailSidebar: () => import('./CaseDetailSidebar.vue'),
      CaseDetailSummary: () => import('./CaseDetailSummary.vue'),
      CaseDetailFooter: () => import('./CaseDetailFooter.vue')
    },

    data: () => ({
      // isLoading: false
    }),

    computed: {
      files() {
        return {
          teleconsultation: this.teleconsultation,
          prescription: this.prescription,
          certificate: this.certificate,
          laboratory: this.laboratory
        }
      },
      routeCaseId() {
        return this.$route.params.id
      },
      storeCaseId() {
        return this.$store.getters['ror/id']
      },
      teleconsultation() {
        return this.$store.getters['ror/teleconsultation']
      },
      prescription() {
        return this.$store.getters['ror/prescription']
      },
      certificate() {
        return this.$store.getters['ror/certificate']
      },
      laboratory() {
        return this.$store.getters['ror/laboratory']
      }
    },

    created() {
      this.getFiles()
    },

    methods: {
      async getFiles() {
        try {
          // this.isLoading = true
          await this.$store.dispatch('ror/getCaseRequest', this.routeCaseId)
          // this.isLoading = false
        }
        catch (e) {
          console.log('[error]', e)
          // this.isLoading = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>